{#if isVisible}
  <div
    class="ne-color-modal"
    transition:fade="{{duration: 200}}">
      <div class="ne-overlay" role="button" on:click="{toggleModal}"></div>
      <div class="ne-color-modal-contents">
        <slot></slot>
      </div>
  </div>
{/if}

<style>
  .ne-color-modal {
    box-sizing: border-box;
  }

  .ne-color-modal :global(*),
  .ne-color-modal :global(*):before,
  .ne-color-modal :global(*):after {
    box-sizing: inherit;
  }

  .ne-color-modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .ne-color-modal-contents {
    position: relative;
    z-index: 1;
    max-width: 320px;
    margin: auto;
  }

  .ne-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }
</style>

<script>
  import { fade } from 'svelte-transitions';

  export let isVisible;
  export let toggleModal;
</script>
